const debounce = (callback, wait = 50) => {
  let timer = null;
  return (...args) => {
    if (timer !== null) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => callback(...args), wait);
  };
};
export {
  debounce
};
//# sourceMappingURL=debounce.js.map
